import React from 'react'
import {copyLink} from "../../../../util/UrlUtil";
import {BodyText, H6Text} from "../../../../styles/AvantTypography";
import {Grid, Tooltip} from "@mui/material";
import FileCopyIcon from "@material-ui/icons/FileCopy"

/**
 * A link to a `ScheduleProctorPage` associated with an individual test code.
 * This link is shared with test takers when they register for an exam.
 *
 * Note: You will have to modify the link to use `http` protocol instead of `https` on local.
 */
export function SchedulingLink({url}: {url: string}) {
    return (
        <Grid
            sx={{
                maxWidth: "18rem",
            }}
            item={true}
        >
            <H6Text>Scheduling Link:</H6Text>
            <BodyText style={{textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}>{url}</BodyText>
            <Tooltip title="Copy link">
                <FileCopyIcon style={{color: "#007bff"}}
                              onClick={() => {
                                  copyLink(url)
                              }}
                />
            </Tooltip>
        </Grid>
    )
}